// extracted by mini-css-extract-plugin
export default {"container":"TL-z","timeTop":"UL-z","timeCountdown":"VL-z","cta":"WL-z","disabled":"XL-z","product":"YL-z"};